import { render, staticRenderFns } from "./imgI.vue?vue&type=template&id=d380a9ac"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d380a9ac')) {
      api.createRecord('d380a9ac', component.options)
    } else {
      api.reload('d380a9ac', component.options)
    }
    module.hot.accept("./imgI.vue?vue&type=template&id=d380a9ac", function () {
      api.rerender('d380a9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgI.vue"
export default component.exports